import React from "react";
import { Link } from "react-router-dom";

const SideBar = (props) => {
  return (
    <div className="list-group sidebar mt-5">
      <Link
        to="/~atanu.metya/people/currentMembers"
        className = {props.currentMembers ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
        aria-current="true"
      >
        Current Members
      </Link>
      <Link to="/~atanu.metya/people/collaborators" className={props.collaborators ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      Collaborators
      </Link>
      <Link to="/~atanu.metya/people/formerMembers" className = {props.formerMembers ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      Former Members
      </Link>
      <Link to="/~atanu.metya/people/groupPhotos" className={props.groupPhotos ? "list-group-item list-group-item-action active": "list-group-item list-group-item-action"}>
      Group Photos
      </Link>
    </div>
  );
};

export default SideBar;
